export default {
  guest: {
    earn_pts: 'Verdien {{points}} ptn op deze bestelling',
    tagline: 'Word beloond. Elke bestelling, elke keer.',
    pick_reward: 'Kies wat je wilt zodra je zover bent',
    free_at: 'gratis bij {{points}} ptn',
    save_at: 'bespaar {{amount}} bij {{points}} ptn',
    nearest: 'dichtstbij',
    cta: 'Begin met verdienen — het is gratis',
    already_member: 'Al lid?',
    sign_in: 'Inloggen',
  },
  member: {
    earning_free: 'Je verdient gratis eten',
    every_euro_one: 'Per {{amount}} besteed = 1 pt. Inwisselen voor gratis items en kortingen.',
    every_euro_other: 'Per {{amount}} besteed = {{count}} ptn. Inwisselen voor gratis items en kortingen.',
    until_redeem: '{{remaining}} ptn tot je kunt beginnen met inwisselen',
    unlock_first: 'Deze bestelling alleen al ontgrendelt je eerste beloning!',
    so_close: 'Zo dicht bij gratis eten!',
    just_more: 'Nog maar {{remaining}} ptn en je kunt beginnen met besparen.',
    pts_to_unlock: '{{remaining}} ptn om beloningen te ontgrendelen',
    this_order_unlocks: 'Deze bestelling brengt je op {{points}} ptn — je kunt bij de volgende bestelling inwisselen!',
    save_next: 'Bespaar tot {{amount}} de volgende keer',
    pts_from_order: '+{{earned}} ptn van deze bestelling — nog maar {{remaining}} over!',
    rewards_value: '= {{amount}} aan beloningen',
    save_this_order: 'Bespaar tot {{amount}} op deze bestelling',
    use_pts: 'Gebruik je {{points}} ptn bij het afrekenen',
    earned_this_order: '+{{points}} ptn verdiend bij deze bestelling',
    current: 'Huidig',
    from_this_order: '+{{points}} van deze bestelling',
    expiration_zero: '{{points}} ptn verlopen vandaag',
    expiration_one: '{{points}} ptn verlopen over 1 dag',
    expiration_other: '{{points}} ptn verlopen over {{count}} dagen',
  },
};
